import { Component }            from '@angular/core';
import { NavController }        from 'ionic-angular';
import { AlertController }      from 'ionic-angular';
import { LoadingController }    from 'ionic-angular';
import { dmHotel }              from '../sign-in/xv-hotel';
import { FacilitiesViewModel }  from './xv-facilities';
import { MLText, mlBroker }     from '../../services/MLText';
import { AppDataBroker }        from '../../services/AppData';
import { SignInPage }           from '../sign-in/sign-in';
import { dmLoading }            from '../loading/loading';

@Component({
   selector:    'page-facilities'
  ,templateUrl: 'facilities.html'
})
export class FacilitiesPage {
    Facilities:   FacilitiesViewModel;
    ShowAlert:    (pTitle: string, pMessage: string) => void;
    NewLoading:   (pMessage: string)                 => dmLoading;
    BackToSignIn: ()                                 => void;

    app: mlBroker;

    constructor(
         public navCtrl:       NavController
        ,public alertCtrl:     AlertController
        ,public loadingCtrl:   LoadingController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel = appDataBroker.GetAppData() as dmHotel;

        this.app  = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );

        this.ShowAlert = (pTitle: string, pMessage: string) => {
            let alert = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.Facilities = new FacilitiesViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.ShowAlert
            ,this.NewLoading
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/facilities/facilities.ts